import { RequestsInstance } from 'api';
const RefreshConfigApiWrapper = (requests: RequestsInstance) => {
	return {
		getRefreshConfig: (timestamp: number) => {
			return requests.get(`misc/refresh-config/${timestamp}`);
		},
	};
};

export default RefreshConfigApiWrapper;
